import React, { useState, useEffect, useRef, useCallback } from 'react';
import './TestimonialSection.css';



const testimonials = [
  {
    id: 1,
    name: 'Ankit Verma',
    initials: 'AV',
    product: 'Energy Booster — Pack of 2',
    rating: 5,
    text: 'The energy supplement has genuinely changed my mornings. I used to feel sluggish until noon but now I feel active right from the start. It\'s Ayurvedic so I feel safe using it long term.',
  },
  {
    id: 2,
    name: 'Neha Kapoor',
    initials: 'NK',
    product: 'Collagen Glow Tablets — Pack of 2',
    rating: 5,
    text: 'I love their collagen tablets. My skin feels so much healthier and more radiant within 3 weeks of use. The effervescent format makes it easy and enjoyable to take every day.',
  },
  {
    id: 3,
    name: 'Ritu Sharma',
    initials: 'RS',
    product: 'Vedo Fat Cutter Ras — Pack of 1',
    rating: 4,
    text: 'Vedo Fat Cutter Ras has helped me lose 4 kg in 6 weeks along with my diet. No side effects at all. I was skeptical about Ayurvedic products before but this one genuinely delivered results.',
  },
  {
    id: 4,
    name: 'Priya Mehta',
    initials: 'PM',
    product: 'Immunity Booster — Pack of 3',
    rating: 5,
    text: 'Ordered the immunity booster for my parents and they\'ve been feeling much better. My father who used to catch colds frequently hasn\'t had one since last 2 months. Highly recommend.',
  },
  {
    id: 5,
    name: 'Sneha Dubey',
    initials: 'SD',
    product: 'Hair Growth Oil — Pack of 2',
    rating: 5,
    text: 'The hair care range is fantastic. My hair fall reduced significantly in just one month. The packaging is also very premium and the product smells so good. Will definitely reorder.',
  },
  {
    id: 6,
    name: 'Vikram Joshi',
    initials: 'VJ',
    product: 'Digestive Care Syrup — Pack of 1',
    rating: 4,
    text: 'Vedonica\'s digestive supplement fixed my bloating issue which I had struggled with for years. After 3 weeks of regular use my digestion is smoother and I feel lighter throughout the day.',
  },
  {
    id: 7,
    name: 'Kavya Gupta',
    initials: 'KG',
    product: 'Stress Relief Capsules — Pack of 2',
    rating: 5,
    text: 'Best Ayurvedic brand I\'ve tried so far. The stress relief capsules actually work — I sleep so much better now. Customer support was also very helpful when I had a query about dosage.',
  },
];

const StarIcon = ({ filled }) => (
  <svg
    className={`ts-star ${filled ? 'ts-star--filled' : 'ts-star--empty'}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
  </svg>
);

const Stars = ({ rating }) => (
  <div className="ts-stars">
    {[1, 2, 3, 4, 5].map((i) => (
      <StarIcon key={i} filled={i <= rating} />
    ))}
  </div>
);

const TestimonialSection = () => {
  const [current, setCurrent] = useState(0);
  const [transitioning, setTransitioning] = useState(false);
  const intervalRef = useRef(null);
  const touchStartX = useRef(null);
  const total = testimonials.length;

  const goTo = useCallback(
    (index) => {
      if (transitioning) return;
      setTransitioning(true);
      setTimeout(() => {
        setCurrent((index + total) % total);
        setTransitioning(false);
      }, 300);
    },
    [transitioning, total]
  );

  const next = useCallback(() => goTo(current + 1), [current, goTo]);
  const prev = useCallback(() => goTo(current - 1), [current, goTo]);

  const resetTimer = useCallback(() => {
    clearInterval(intervalRef.current);
    intervalRef.current = setInterval(next, 5000);
  }, [next]);

  useEffect(() => {
    intervalRef.current = setInterval(next, 5000);
    return () => clearInterval(intervalRef.current);
  }, [next]);

  const handlePrev = () => { prev(); resetTimer(); };
  const handleNext = () => { next(); resetTimer(); };
  const handleDot = (i) => { if (i !== current) { goTo(i); resetTimer(); } };

  const handleTouchStart = (e) => { touchStartX.current = e.touches[0].clientX; };
  const handleTouchEnd = (e) => {
    if (touchStartX.current === null) return;
    const diff = touchStartX.current - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 40) { diff > 0 ? handleNext() : handlePrev(); }
    touchStartX.current = null;
  };

  const t = testimonials[current];

  return (
    <section className="ts-section">

      {/* Header */}
      <div className="ts-header">
        <h4 className="ts-title">What our customers say</h4>
        <p className="ts-sub">Real experiences shared by people who trust our products</p>
        <div className="ts-trust">
          <span className="ts-badge">4.8 avg rating</span>
          <span className="ts-badge">500+ verified reviews</span>
          <span className="ts-badge">100% Ayurvedic</span>
        </div>
      </div>

      {/* Card */}
      <div
        className="ts-viewport"
        onTouchStart={handleTouchStart}
        onTouchEnd={handleTouchEnd}
      >
        <div className={`ts-card ${transitioning ? 'ts-card--exit' : 'ts-card--enter'}`}>
          {/* <span className="ts-quote">"</span> */}
          <Stars rating={t.rating} />
          <p className="ts-text">{t.text}</p>
          <div className="ts-author">
            <div className="ts-avatar">{t.initials}</div>
            <div>
              <div className="ts-name">{t.name}</div>
              <div className="ts-product">{t.product}</div>
              <div className="ts-verified">
                <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="#2d6a14" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="20 6 9 17 4 12" />
                </svg>
                Verified purchase
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Controls */}
      <div className="ts-controls">
        <button className="ts-btn" onClick={handlePrev} aria-label="Previous">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="15 18 9 12 15 6" />
          </svg>
        </button>

        <div className="ts-dots">
          {testimonials.map((_, i) => (
            <button
              key={i}
              className={`ts-dot ${i === current ? 'ts-dot--active' : ''}`}
              onClick={() => handleDot(i)}
              aria-label={`Go to review ${i + 1}`}
            />
          ))}
        </div>

        <span className="ts-counter">{current + 1} / {total}</span>

        <button className="ts-btn" onClick={handleNext} aria-label="Next">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="9 18 15 12 9 6" />
          </svg>
        </button>
      </div>

    </section>
  );
};

export default TestimonialSection;